import {TooltipModel} from "./tooltip.model";

export class OnBoardingTooltipModel extends TooltipModel {
    get display(): boolean {

        const orbitOverlayConsumersCount = this.services.overlay.countCurrentConsumers(consumer => {
            if(consumer === this.tooltipService) {
                return false;
            }

            return consumer.needsOverlay;
        });

        const sdkHasOpenOverlays = this.services.sdk.hasOpenOverlays;
        const areRunningApps = this.services.appLauncher.isThereRunningApps;
        const areOpenDialogs = this.services.dialog.hasOpenDialogs;

        //The reason we put the values in those variables is to make sure that this display getter depends on all these observables.

        return !(sdkHasOpenOverlays
            || areRunningApps
            || areOpenDialogs
            || orbitOverlayConsumersCount > 0);
    }
}